export const LIMBO_PATH_NAME = '/crypto-limbo/';
export const MINES_PATH_NAME = '/crypto-mines/';
export const DICE_PATH_NAME = '/crypto-dice/';
export const HILO_PATH_NAME = '/crypto-hilo/';
export const ALTERNATIVE_DICE_PATH_NAME = '/crypto-ultimatedice/';
export const PLINKO_PATH_NAME = '/crypto-plinko/';
export const BLACK_JACK_PATH_NAME = '/crypto-blackjack/';
export const KENO_PATH_NAME = '/crypto-keno/';
export const WHEEL_PATH_NAME = '/crypto-wheel/';
export const CRASH_PATH_NAME = '/crypto-crash/';
export const COIN_FLIP_PATH_NAME = '/crypto-coinflip/';
export const FOOTBALL_PATH_NAME = '/crypto-football/';
export const DRIFT_PATH_NAME = '/crypto-drift/';
export const FISHING_PATH_NAME = '/crypto-fishing/';
export const ROULETTE_PATH_NAME = '/crypto-roulette/';
export const BACCARAT_PATH_NAME = '/crypto-baccarat/';
export const DOUBLE_DICE_PATH_NAME = '/crypto-double-dice/';
export const FAST_TRADE_PATH_NAME = '/crypto-fasttrade/';
export const LIMBO_10_PATH_NAME = '/crypto-10limbo/';
export const HANDS_BLACKJACK_PATH_NAME = '/crypto-handsblackjack/';
export const TOWER_PATH_NAME = '/crypto-tower/';

export const POWER_OF_GODS_PATH_NAME = '/crypto-powerofgods/';

export const SOCKET_PATH_NAME = {
  [LIMBO_PATH_NAME]: 'limbo',
  [MINES_PATH_NAME]: 'mines',
  [DICE_PATH_NAME]: 'dice',
  [HILO_PATH_NAME]: 'hilo',
  [ALTERNATIVE_DICE_PATH_NAME]: 'ultimatedice',
  [PLINKO_PATH_NAME]: 'plinko',
  [BLACK_JACK_PATH_NAME]: 'blackjack',
  [KENO_PATH_NAME]: 'keno',
  [WHEEL_PATH_NAME]: 'wheel',
  [CRASH_PATH_NAME]: 'crash',
  [COIN_FLIP_PATH_NAME]: 'coinflip',
  [FOOTBALL_PATH_NAME]: 'football',
  [DRIFT_PATH_NAME]: 'drift',
  [FISHING_PATH_NAME]: 'fishing',
  [ROULETTE_PATH_NAME]: 'roulette',
  [BACCARAT_PATH_NAME]: 'baccarat',
  [DOUBLE_DICE_PATH_NAME]: 'double-dice',
  [FAST_TRADE_PATH_NAME]: 'fasttrade',
  [LIMBO_10_PATH_NAME]: '10limbo',
  [HANDS_BLACKJACK_PATH_NAME]: 'handsblackjack',
  [TOWER_PATH_NAME]: 'tower',
  [POWER_OF_GODS_PATH_NAME]: 'powerofgods',
};

export const detectSocketPath = (pathName) => {
  return `crypto-${SOCKET_PATH_NAME[pathName]}`;
};
